function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.452 6.707a.69.69 0 000-1 .75.75 0 00-1.035 0l-2.64 3.328V1.262c0-.39-.373-.706-.777-.706s-.778.316-.778.706v7.76L1.583 5.707a.75.75 0 00-1.035.001.69.69 0 000 1l3.934 4.53a.75.75 0 001.036 0l3.934-4.53z",
  fill: "#637EFF",
  fillRule: "evenodd"
});

var SvgDownArrow = function SvgDownArrow(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12"
  }, props), _ref);
};

export default SvgDownArrow;